import {
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SCHEDULED_SESSIONS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CHAT,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_UPCOMING_SESSIONS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_PAST_SESSIONS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SETTINGS,
	ROUTE_WE_SPIN_GAME_ROOM_PREVIEW,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_EDIT_SESSION,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_VIEW_DETAILS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_SUCCESS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_GAMES_LIST
} from '../../constants/we-spin-route-constants.js';
import {
	WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD,
	WE_SPIN_DASHBOARD_TAB_ITEM_LIVE_DASHBOARD,
	WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM,
	WE_SPIN_DASHBOARD_TAB_ITEM_CALENDAR,
	WE_SPIN_DASHBOARD_TAB_ITEM_CHAT,
	WE_SPIN_DASHBOARD_TAB_ITEM_SETTINGS
} from '../../constants/we-spin-dashboard-text-keys.js';
import {
	WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD_DATA_AT,
	WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM_DATA_AT,
	WE_SPIN_DASHBOARD_TAB_ITEM_MY_STREAMS_DATA_AT,
	WE_SPIN_DASHBOARD_TAB_ITEM_CHAT_DATA_AT,
	WE_SPIN_DASHBOARD_TAB_ITEM_SETTINGS_DATA_AT,
	WE_SPIN_DASHBOARD_TAB_ITEM_BALANCE_DATA_AT
} from '../../constants/we-spin-data-at-attributes.js';
import { WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE } from '../../constants/we-spin-text-keys';

export const TAB_VISIBILITY = {
	ON_LIVE_EVENT: 'ON_LIVE_EVENT',
	ON_OFFLINE: 'ON_OFFLINE',
	IS_STREAMER: 'IS_STREAMER',
	IS_PRIVATE_STREAMER: 'IS_PRIVATE_STREAMER'
};

export const TAB_ITEMS = [
	{
		labelKey: WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD,
		labelKeyOptional: WE_SPIN_DASHBOARD_TAB_ITEM_LIVE_DASHBOARD,
		labelKeyLive: WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD,
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD,
		headerKey: WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD,
		dataAt: WE_SPIN_DASHBOARD_TAB_ITEM_DASHBOARD_DATA_AT,
		active: [ROUTE_ACCOUNT_WE_SPIN_DASHBOARD],
		chosen: false,
		visibility: [
			TAB_VISIBILITY.ON_LIVE_EVENT,
			TAB_VISIBILITY.ON_OFFLINE,
			TAB_VISIBILITY.IS_STREAMER,
			TAB_VISIBILITY.IS_PRIVATE_STREAMER
		]
	},
	{
		labelKey: WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE,
		labelKeyLive: WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE,
		link: ROUTE_WE_SPIN_GAME_ROOM_PREVIEW,
		headerKey: WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM,
		dataAt: WE_SPIN_DASHBOARD_TAB_ITEM_BALANCE_DATA_AT,
		active: [ROUTE_WE_SPIN_GAME_ROOM_PREVIEW],
		chosen: false,
		visibility: [TAB_VISIBILITY.ON_LIVE_EVENT, TAB_VISIBILITY.IS_STREAMER, TAB_VISIBILITY.IS_PRIVATE_STREAMER]
	},
	{
		labelKey: WE_SPIN_DASHBOARD_TAB_ITEM_CALENDAR,
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_UPCOMING_SESSIONS,
		headerKey: WE_SPIN_DASHBOARD_TAB_ITEM_CALENDAR,
		dataAt: WE_SPIN_DASHBOARD_TAB_ITEM_MY_STREAMS_DATA_AT,
		active: [
			ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SCHEDULED_SESSIONS,
			ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_UPCOMING_SESSIONS,
			ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_PAST_SESSIONS
		],
		chosen: false,
		visibility: [TAB_VISIBILITY.ON_OFFLINE, TAB_VISIBILITY.IS_STREAMER, TAB_VISIBILITY.IS_PRIVATE_STREAMER]
	},
	{
		labelKey: WE_SPIN_DASHBOARD_TAB_ITEM_CHAT,
		labelKeyLive: WE_SPIN_DASHBOARD_TAB_ITEM_CHAT,
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CHAT,
		headerKey: WE_SPIN_DASHBOARD_TAB_ITEM_CHAT,
		dataAt: WE_SPIN_DASHBOARD_TAB_ITEM_CHAT_DATA_AT,
		active: [ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CHAT],
		chosen: false,
		visibility: [TAB_VISIBILITY.ON_LIVE_EVENT, TAB_VISIBILITY.IS_STREAMER]
	},
	{
		labelKey: WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM,
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION,
		headerKey: WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM,
		dataAt: WE_SPIN_DASHBOARD_TAB_ITEM_ADD_STREAM_DATA_AT,
		active: [ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION],
		chosen: false,
		visibility: [TAB_VISIBILITY.ON_OFFLINE, TAB_VISIBILITY.IS_STREAMER, TAB_VISIBILITY.IS_PRIVATE_STREAMER]
	},
	{
		labelKey: WE_SPIN_DASHBOARD_TAB_ITEM_SETTINGS,
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SETTINGS,
		headerKey: WE_SPIN_DASHBOARD_TAB_ITEM_SETTINGS,
		dataAt: WE_SPIN_DASHBOARD_TAB_ITEM_SETTINGS_DATA_AT,
		active: [ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SETTINGS],
		chosen: false,
		hidden: true,
		visibility: []
	},
	{
		labelKey: '',
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_EDIT_SESSION,
		headerKey: 'WE_SPIN_DASHBOARD_LIVE_EVENT_DETAIL_EDIT_EVENT',
		dataAt: '',
		active: [ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_EDIT_SESSION],
		chosen: false,
		hidden: true,
		visibility: []
	},
	{
		labelKey: '',
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_SUCCESS,
		headerKey: 'ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_SUCCESS',
		dataAt: '',
		active: [ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_SUCCESS],
		chosen: false,
		hidden: true,
		visibility: []
	},
	{
		labelKey: '',
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_VIEW_DETAILS,
		headerKey: '',
		dataAt: '',
		active: [ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_VIEW_DETAILS],
		chosen: false,
		hidden: true,
		visibility: []
	},
	{
		labelKey: '',
		link: ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_GAMES_LIST,
		headerKey: '',
		dataAt: '',
		active: [ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_GAMES_LIST],
		chosen: false,
		hidden: true,
		visibility: []
	}
];
